console.clear()

/////////// IMPORTS ///////////
import * as THREE from 'three'
import { PointerLockControls } from 'three/addons/controls/PointerLockControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import {RGBELoader} from 'three/examples/jsm/loaders/RGBELoader.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import gsap from 'gsap'



/////////// VARIABLES ///////////
const canvasBackground = document.querySelector('.home__background')
const homeSection = document.querySelector('.homeSection')
const aboutSection = document.querySelector('.aboutSection')
const instructions = document.querySelector('.instructions')
const lancement = document.querySelector('.lancement')
const footer = document.querySelector('.footer')
const aboutBtn = document.querySelector('.about')
const start = document.querySelector('.start')
const header = document.querySelector('.header')
const home = document.querySelector('.home')
const homeTitle = document.querySelector('.home__title')
const homeP = document.querySelector('.home__p--h')
const choice= document.querySelector('.choice')
const max3D= document.querySelector('.choice__btnEl--max')
const min3D= document.querySelector('.choice__btnEl--min')
const modal = document.querySelector('.modal')
const modalContent = document.querySelector('.modal__content')
const close = document.querySelector('.button--close')
const loader = document.querySelector('.loader')
const percentText = document.querySelector('.loader__p')
const bars = document.querySelectorAll('.loader__el')
const jsonData = await fetch('json/data.json').then(response => response.json())
let min = false
let max = false
let shouldRender = false



/////////// CODE ///////////
if (home){
    /**
     * About
     */
    aboutBtn.addEventListener('click', () => {
        homeSection.classList.toggle('hide')
        aboutSection.classList.toggle('hide')
        footer.classList.toggle('hide')
        instructions.classList.toggle('hide')
        aboutBtn.classList.toggle('button--headerClose')
    })


    /**
     * LOADING 3D SCENE
     */
    // Loading
    if (window.innerWidth >= 1000) {
        initThreeScene();
    } else {
        window.addEventListener('load', () => {

            let progress = 0

            const interval = setInterval(() => {
                if (progress >= 100) {
                    clearInterval(interval)
                    loader.classList.add('hide')
                    homeTitle.classList.add('home__title--show')

                    setTimeout(() => {
                        header.classList.remove('hide')
                        instructions.classList.remove('hide')
                        start.classList.remove('hide')
                    }, 400)
                    return
                }

                progress += 1
                updateLoader(progress)
            }, 20) // 20ms * 100 = ~2 secondes
        

            function updateLoader(progress) {
                percentText.textContent = `${progress}%`

                const activeBars = Math.floor(progress / 10)
                bars.forEach((bar, index) => {
                    if (index < activeBars) {
                        bar.classList.add('loader__el--white')
                    } else {
                        bar.classList.remove('loader__el--white')
                    }
                })
            }
        })
    }

    function initThreeScene () {
        /**
         * Esc
         */
        let manualUnlock = false

        document.addEventListener('pointerlockchange', () => {
        const isLocked = document.pointerLockElement !== null

        if (!isLocked) {
            if (!manualUnlock) {
                homeSection.classList.remove('hide')
                aboutBtn.classList.remove('hide')
                instructions.classList.remove('hide')
                header.classList.remove('hide')
                canvasScene.classList.add('webgl--renderer')
                homeTitle.classList.add('home__title--show')
                shouldRender = false

                setTimeout (() => {
                    homeP.classList.remove('hide')
                    start.classList.remove('hide')
                }, 300)
            }
            manualUnlock = false 
        }
        })


        /**
         * Full screen
         */
        const fullScreenButton = document.querySelector('.header__button--fullScreen')

        function toggleFullScreen() {
            const elem = document.documentElement

            if (!document.fullscreenElement) {
                if (elem.requestFullscreen) {
                    elem.requestFullscreen()
                } else if (elem.webkitRequestFullscreen) {
                    elem.webkitRequestFullscreen()
                } else if (elem.msRequestFullscreen) {
                    elem.msRequestFullscreen()
                }
                fullScreenButton.classList.add('header__button--fullScreenQuit')
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                }
                fullScreenButton.classList.remove('header__button--fullScreenQuit')
            }
        }

        fullScreenButton.addEventListener('click', toggleFullScreen)

        document.addEventListener('keydown', (e) => {
            if (e.key.toLowerCase() === 'f') {
                toggleFullScreen()
            }
        })


        /**
         * Sounds
         */
        //Mute
        let isMuted = false
        const soundBtn = document.querySelector('.header__button--sound')

        function toggleSound() {
            isMuted = !isMuted

            if (isMuted) {
                ambianceAudio.pause()
                Object.values(sounds).forEach(sound => sound.setVolume(0))
            } else {
                checkProximity()
            }
            soundBtn.classList.toggle('header__button--soundMuted')
        }

        soundBtn.addEventListener('click', toggleSound)

        document.addEventListener('keydown', (e) => {
            if (e.key.toLowerCase() === 'm') {
                toggleSound()
            }
        })


        /**
         * BACK INITIAL POSITION
         */
        window.addEventListener('keydown', (event) => {
        if (event.key.toLowerCase() === 'r') {
            gsap.timeline()
            .to(camera.position, {
                duration: 1.5,
                x: -0.77, 
                y: .06,
                z: -2.27,
                ease: 'power2.inOut'
            }, 0)
            .to(camera.rotation, {
                duration: 1.5,
                x: -3.10,
                y: -.83,
                z: -3.11,
                ease: 'power2.inOut'
            }, 0)
        }
        })

        //Ambient Music
        const ambianceAudio = new Audio('music/ancientWinds.mp3')
        ambianceAudio.loop = true
        ambianceAudio.volume = 0.7

        let ambianceTargetVolume = 0.7
        let ambianceFadeSpeed = 0.02 

        function updateAmbianceVolume() {
            if (ambianceAudio) {
                const target = isMuted ? 0 : ambianceTargetVolume
                const current = ambianceAudio.volume
                const diff = target - current

                if (Math.abs(diff) > 0.01) {
                    ambianceAudio.volume += diff * ambianceFadeSpeed
                } else {
                    ambianceAudio.volume = target
                }
            }
        }

        //Steps
        const stepLeft = new Audio('music/leftStep.mp3')
        const stepRight = new Audio('music/rightStep.mp3')
        stepLeft.volume = .9
        stepRight.volume = .9

        let isMoving = false
        let stepTimer = null
        let nextStepLeft = true
        let muted = false

        function playFootstep() {
        if (muted) return

        const stepSound = nextStepLeft ? stepLeft : stepRight
        stepSound.currentTime = 0
        stepSound.play()
        nextStepLeft = !nextStepLeft
        }



        /////////// SCENE 3D ///////////
        /**
         * Base
         */
        const canvasScene = document.querySelector('canvas.webgl')
        const scene = new THREE.Scene()

        /**
         * Walk
         */
        let bobbingTime = 0
        const bobbingAmplitude = 0.002
        const bobbingSpeed = 8


        /**
         * Loader
         */
        const loadingManager = new THREE.LoadingManager()

        loadingManager.onProgress = function (url, itemsLoaded, itemsTotal) {
            const progress = Math.floor((itemsLoaded / itemsTotal) * 100)
            updateLoader(progress)
        }

        function updateLoader(progress) {
            const percentText = document.querySelector('.loader__p')
            const bars = document.querySelectorAll('.loader__el')

            percentText.textContent = `${progress}%`

            const activeBars = Math.floor(progress / 10)
            bars.forEach((bar, index) => {
                if (index < activeBars) {
                    bar.classList.add('loader__el--white')
                } else {
                    bar.classList.remove('loader__el--white')
                }
            })
        }


        /**
         * Environment map
         */
        const rgbeLoader = new RGBELoader(loadingManager)
        rgbeLoader.load('textures/ciel.hdr', (environmentMap) => {
            environmentMap.mapping = THREE.EquirectangularReflectionMapping
            scene.background = environmentMap
            scene.environment = environmentMap
        })
        scene.fog = new THREE.Fog('#000000', 0.4, 0.55)


        /**
         * Blender model import
         */
        const loader = new GLTFLoader(loadingManager)
        let terrainMesh = null
        const spheresExt = []
        const spheresInt = []

        // Load main scene
        function loadModel(path) {
            loader.load(
                path,
                (glb) => {
                    const model = glb.scene
                    model.scale.set(0.1, 0.1, 0.1)
                    model.position.set(0, 0, 0)
                    scene.add(model)

                    model.traverse((child) => {
                        if (child.isMesh) {
                            const worldPosition = new THREE.Vector3()
                            child.getWorldPosition(worldPosition)

                            if (child.name === 'field') {
                                terrainMesh = child
                            }
                            if (child.name.startsWith("sphereExterne")) {
                                spheresExt.push(child)
                            }
                            if (child.name.startsWith("sphereInterne")) {
                                spheresInt.push(child)
                            }
                            if (child.name.startsWith("lightPurple")) {
                                child.material.metalness = 0
                                child.material.roughness = 0.15
                                child.material.transmission = 1
                                child.material.ior = 1.5
                                child.material.thickness = 0.5
                                child.material.color = new THREE.Color(0x6D1C7A)
                                child.material.emissive = new THREE.Color(0x6D1C7A)
                                child.material.emissiveIntensity = 4
                            }
                            if (child.name.startsWith("lightBlue")) {
                                child.material.metalness = 0
                                child.material.roughness = 0.15
                                child.material.transmission = 1
                                child.material.ior = 1.5
                                child.material.thickness = 0.5
                                child.material.color = new THREE.Color(0x3BFFF9)
                                child.material.emissive = new THREE.Color(0x3BFFF9)
                                child.material.emissiveIntensity = 4
                            }

                            child.material.side = THREE.FrontSide
                        }
                    })

                    // ✅ On cache le loader ici quand tout est bien chargé et ajouté
                    updateLoader(100)
                    const loaderElem = document.querySelector('.loader')
                    loaderElem.classList.add('hide')
                    homeTitle.classList.add('home__title--show')

                    setTimeout(() => {
                        header.classList.remove('hide')
                        instructions.classList.remove('hide')
                        homeP.classList.remove('hide')
                        start.classList.remove('hide')
                    }, 400)
                }
            )
        }

        max3D.addEventListener('click', () => {
            max = true
            choice.classList.add('hide')
            loadModel('3D/environment.glb')
        })
        min3D.addEventListener('click', () => {
            min = true
            choice.classList.add('hide')
            loadModel('3D/environmentMinimal.glb')
        })


        /**
         * Sizes
         */
        const sizes = {
            width: window.innerWidth,
            height: window.innerHeight
        }
        document.documentElement.style.setProperty('--screen-width', sizes.width + 'px')
        document.documentElement.style.setProperty('--screen-height', sizes.height + 'px')

        window.addEventListener('resize', () => {
            sizes.width = window.innerWidth
            sizes.height = window.innerHeight

            camera.aspect = sizes.width / sizes.height
            camera.updateProjectionMatrix()

            renderer.setSize(sizes.width, sizes.height)
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

            document.documentElement.style.setProperty('--screen-width', sizes.width + 'px')
            document.documentElement.style.setProperty('--screen-height', sizes.height + 'px')
        })


        /**
         * Camera
         */
        const camera = new THREE.PerspectiveCamera(
            60, // champ de vision réduit
            window.innerWidth / window.innerHeight,
            0.005, // plan proche
            .55 // plan éloigné, increased to see more of the scene from above
        )

        // Camera
        camera.position.set(-.77, .06, -2.27) 
        camera.rotation.set(-3.10, -.83, -3.11)

        // Spline
        const pathPoints = []

        fetch('json/positionSpline.json')
        .then(response => {
            if (!response.ok) {
            throw new Error(`Erreur HTTP : ${response.status}`)
            }
            return response.json()
        })
        .then(data => {
            data.forEach(point => {
            const vector = new THREE.Vector3(point.x, point.y, point.z)
            pathPoints.push(vector)
            })
        })
        .catch(error => {
            console.error("Erreur lors du chargement du fichier JSON :", error)
        })
        
        const pathCurve = new THREE.CatmullRomCurve3(pathPoints)

        // Controls
        const controls = new PointerLockControls(camera, canvasScene)

        let firstClick = true

        start.addEventListener('click', () => {
            homeSection.classList.add('hide')
            aboutBtn.classList.add('hide')
            canvasBackground.classList.add('hide')
            ambianceAudio.play()
            shouldRender = true
            setTimeout(() => {
                canvasScene.classList.remove('webgl--renderer')
            }, 200)
            setTimeout(() => {
                homeTitle.classList.remove('home__title--show')
                homeP.classList.add('hide')
                start.classList.add('hide')
            }, 600)

            if (firstClick) {
                lancement.classList.remove('hide')
                controls.lock()

                setTimeout(() => {
                lancement.classList.add('hide')
                header.classList.add('hide')
                }, 4000)

                setTimeout(() => {
                instructions.classList.add('hide')
                }, 6000)

                firstClick = false
            } else {
                controls.lock()
                instructions.classList.add('hide')
                header.classList.add('hide')
            }
        })

        const moveSpeed = 0.08
        const velocity = new THREE.Vector3()
        const direction = new THREE.Vector3()
        const frontVector = new THREE.Vector3()
        const sideVector = new THREE.Vector3()

        let moveForward = false
        let moveBackward = false
        let moveLeft = false
        let moveRight = false

        const onKeyDown = function (event) {
        switch (event.code) {
            case 'ArrowUp':
            case 'KeyW':
            moveForward = true
            break
            case 'ArrowLeft':
            case 'KeyA':
            moveLeft = true
            break
            case 'ArrowDown':
            case 'KeyS':
            moveBackward = true
            break
            case 'ArrowRight':
            case 'KeyD':
            moveRight = true
            break
        }

        if (!isMoving && (moveForward || moveBackward || moveLeft || moveRight)) {
            isMoving = true
            stepTimer = setInterval(playFootstep, 300)
        }
        }

        const onKeyUp = function (event) {
        switch (event.code) {
            case 'ArrowUp':
            case 'KeyW':
            moveForward = false
            break
            case 'ArrowLeft':
            case 'KeyA':
            moveLeft = false
            break
            case 'ArrowDown':
            case 'KeyS':
            moveBackward = false
            break
            case 'ArrowRight':
            case 'KeyD':
            moveRight = false
            break
        }

        if (!moveForward && !moveBackward && !moveLeft && !moveRight) {
            isMoving = false
            clearInterval(stepTimer)
            stepTimer = null
        }
        }


        document.addEventListener('keydown', onKeyDown)
        document.addEventListener('keyup', onKeyUp)


        /**
         * Lights
         */
        // Sunlight
        const lightColor = 0x3049BF 
        const lightStrength = 10    
        const lightScale = 2.861   
        const pointLight = new THREE.PointLight(lightColor, lightStrength)
        pointLight.position.set(.54683, -.092626, 2.3168)
        pointLight.rotation.set(0.526, 0, 0)
        pointLight.scale.set(lightScale, lightScale, lightScale)
        scene.add(pointLight)

        // Ambient Light
        const ambientLight = new THREE.AmbientLight(0x2B48BD, .1) 
        scene.add(ambientLight)

        // Camera Light
        const whiteLight = new THREE.PointLight(0x2B48BD, 1.1, 10) 
        whiteLight.position.set(0, 0, 0) 
        scene.add(whiteLight)


        /**
         * Music
         */
        const audioListeners = new THREE.AudioListener()
        camera.add(audioListeners)

        const sounds = {}
        const audioLoader = new THREE.AudioLoader(loadingManager)

        const soundConfigs = [
            { name: 'Euphoric Hardstyle', path: 'music/euphoricHardstyle.mp3' },
            { name: 'Rawstyle', path: 'music/raw.mp3' },
            { name: 'Frenchcore', path: 'music/frenchcore.mp3' },
            { name: 'Industrial Hardcore', path: 'music/industrial.mp3' },
            { name: 'Extratone', path: 'music/extratone.mp3' },
            { name: 'Gabber', path: 'music/gabber.mp3' },
            { name: 'J-Core', path: 'music/jCore.mp3' },
            { name: 'Jumpstyle', path: 'music/jumpstyle.mp3' },
            { name: 'UK Hardcore', path: 'music/ukHardcore.mp3' },
            { name: 'Uptempo', path: 'music/uptempo.mp3' },
            { name: 'Frenchcore', path: 'music/frenchcore.mp3' },
            { name: 'Speedcore', path: 'music/speedcore.mp3' },
            { name: 'Darkcore', path: 'music/darkcore.mp3' },
            { name: 'Hardcore', path: 'music/hardcore.mp3' },
            { name: 'Makina', path: 'music/makina.mp3' },
            { name: 'Happy Hardcore', path: 'music/happy.mp3' },
            { name: 'Terrorcore', path: 'music/terror.mp3' }
            
        ]
        soundConfigs.forEach(({ name, path }) => {
            const sound = new THREE.Audio(audioListeners)
            audioLoader.load(path, (buffer) => {
                sound.setBuffer(buffer)
                sound.setLoop(true)
                sound.setVolume(1)
            })
            sounds[name] = sound
        })


        /**
         * Objects
         */
        // Spheres
        const materialSphereConsult = new THREE.MeshPhysicalMaterial({
            metalness: 0,
            roughness: 0.15,
            transmission: 1,
            ior: 1.5,
            thickness: 0.5,
            color: 0xBB4FFF,
            emissive: 0xBB4FFF, 
            emissiveIntensity: 10 
        })

        const materialSphere = new THREE.MeshPhysicalMaterial({
            metalness: 0,
            roughness: 0.15,
            transmission: 1,
            ior: 1.5,
            thickness: 0.5,
        })

        const materialText = new THREE.MeshPhysicalMaterial({
            metalness: 1,
            roughness: .6,
            ior: 1.5,
            color: 0xE6F0EE,
        })

        const groupConfigs = [
            { 
                name: 'Euphoric Hardstyle', 
                position: { x: -0.7299199104309082, y: 0.05884556770324707, z: -5.874841690063477 }, 
                path: 'music/euphoricHardstyle.mp3'
            },
            { 
                name: 'Uptempo', 
                position: { x: 2.503182029724121, y: 0.6846701622009278, z: 0.7403594970703126 },
                path: 'music/uptempo.mp3'
            },
            { 
                name: 'Rawstyle', 
                position: { x: -1.9451837539672852, y: 0.07011446952819825, z: -4.72588005065918 },
                path: 'music/raw.mp3'
            },
            { 
                name: 'Speedcore', 
                position: { x: -0.11929454803466798, y: 1.282417678833008, z: 0.2605757713317871 },
                path: 'music/speedcore.mp3'
            },
            { 
                name: 'Gabber', 
                position: { x: -1.3445391654968262, y: 0.13599759340286255, z: -1.4720508575439455 },
                path: 'music/gabber.mp3'
            },
            { 
                name: 'Frenchcore', 
                position: { x: 1.2889531135559082, y: 0.8538284301757812, z: 1.0297032356262208 },
                path: 'music/frenchcore.mp3'
            },
            { 
                name: 'UK Hardcore', 
                position: { x: 1.8589447021484375, y: 0.5402404308319092, z: -0.8119916915893555 },
                path: 'music/ukHardcore.mp3'
            },
            { 
                name: 'Jumpstyle', 
                position: { x: 1.1075013160705567, y: 0.06114683151245118, z: -5.775101470947266 },
                path: 'music/jumpstyle.mp3'
            },
            { 
                name: 'Makina', 
                position: { x: -1.5302441596984864, y: 0.05884556770324707, z: -3.662602233886719 },
                path: 'music/makina.mp3'
            },
            { 
                name: 'J-Core', 
                position: { x: -0.993385124206543, y: 0.6734091758728028, z: 1.2769237518310548 },
                path: 'music/jCore.mp3'
            },
            { 
                name: 'Darkcore', 
                position: { x: 1.13197078704834, y: 0.06890271902084351, z: -2.433540916442871 },
                path: 'music/darkcore.mp3'
            },
            { 
                name: 'Hardcore', 
                position: { x: -0.6150985717773438, y: 0.05884556770324707, z: -2.910929870605469 },
                path: 'music/hardcore.mp3'
            },
            { 
                name: 'Terrorcore', 
                position: { x: -0.2644178628921509, y: 0.5589656352996827, z: 1.9838081359863282 },
                path: 'music/terror.mp3'
            },
            { 
                name: 'Happy Hardcore', 
                position: { x: 0.23037381172180177, y: 0.539551067352295, z: -1.0651521682739258 },
                path: 'music/happy.mp3'
            },
            { 
                name: 'Industrial Hardcore', 
                position: { x: 1.0581399917602539, y: 0.06813697814941407, z: -4.348429870605469 },
                path: 'music/industrial.mp3'
            }
        ]
        const sphereGroups = []

        const fontLoader = new FontLoader(loadingManager)
        fontLoader.load('fonts/Valve_Plain Medium_Regular.json', (font) => {
            groupConfigs.forEach(config => createSphereGroup(config.name, config.position, materialSphere, materialText, font))
        })

        function createSphereGroup(name, position, materialSphere, materialText, font) {
            const group = new THREE.Group()
            scene.add(group)
            group.position.set(position.x, position.y || 0, position.z)

            if (sounds[name]) {
                group.add(sounds[name])
            }

            // Sphere
            const sphere = new THREE.Mesh(
                new THREE.SphereGeometry(.02, 20, 20),
                materialSphere
            )
            group.add(sphere)

            // Texte
            const textGeometry = new TextGeometry(name, {
                font: font,
                size: 0.01,
                depth: 0.002,
                //curveSegments: 5,
                //bevelEnabled: true,
                //bevelThickness: 0.03,
                //bevelSize: 0.02,
                //bevelOffset: 0,
                //bevelSegments: 4
            })
            textGeometry.center()

            const textMesh = new THREE.Mesh(textGeometry, materialText) 
            group.add(textMesh)
            textMesh.position.y = .05

            group.name = name
            sphereGroups.push({ group, textMesh }) 
        }


        /**
         * Interactions
         */
        // Camera Distance
        const modalInfo = document.querySelector('.nearSphere')

        function checkProximity() {
            const playerPos = camera.position
            let isNear = false
            let isNearAnySoundSphere = false

            sphereGroups.forEach(({ group }) => {
                const distance = playerPos.distanceTo(group.position)
                const sound = sounds[group.name]

                if (sound) {
                    const maxDistance = 0.5
                    const minDistance = 0.1
                    const playDistance = 0.45
                    const stopDistance = 0.55

                    if (distance < playDistance && !sound.isPlaying) {
                        sound.play()
                    } else if (distance > stopDistance && sound.isPlaying) {
                        sound.stop()
                    }

                    if (!isMuted) {
                        let volume = 1 - (distance - minDistance) / (maxDistance - minDistance)
                        volume = Math.max(0, Math.min(1, volume))
                        const currentVolume = sound.getVolume()
                        const smoothedVolume = THREE.MathUtils.lerp(currentVolume, volume, 0.1)
                        sound.setVolume(smoothedVolume)
                    } else {
                        sound.setVolume(0)
                    }
                }

                if (distance < 0.5) {
                    isNearAnySoundSphere = true
                }

                if (distance < 0.2) {
                    isNear = true
                }
            })

            if (isNearAnySoundSphere) {
                ambianceTargetVolume = 0
                if (!ambianceAudio.paused && !isMuted) {
                    ambianceAudio.pause()
                }
            } else {
                ambianceTargetVolume = 0.5
                if (ambianceAudio.paused && !isMuted) {
                    ambianceAudio.play().catch(() => {})
                }
            }

            modalInfo.classList.toggle('nearSphere--visible', isNear)
        }

        //Informations
        var togglePressE = false
        var isLocked = false

        window.addEventListener('keydown', (event) => {
            if (event.key !== 'e' && event.key !== 'E') return
            togglePressE = true

            let closestGroup = null
            sphereGroups.forEach(({ group }) => {
                const distance = camera.position.distanceTo(group.position)
                if (distance < .2) {
                    if (!closestGroup || distance < closestGroup.distance) {
                        closestGroup = { group, distance }
                    }
                }
            })

            if (closestGroup) {
                const { group } = closestGroup
                const genreData = jsonData.find(item => item.title === group.name)
                isLocked = true

                if (genreData) {
                    modal.classList.add('modal--visible')
                    header.classList.remove('hide')

                    // Change the material of the sphere to materialSphereConsult
                    group.children.forEach((child) => {
                        if (child.isMesh && child.geometry.type === 'SphereGeometry') {
                            child.material = materialSphereConsult
                        }
                    })

                    // Pointer lock control
                    if (isLocked) {
                        manualUnlock = true
                        controls.unlock()
                    } else {
                        controls.lock()
                    }


                    // Modale content
                    modalContent.innerHTML = `
                        <h2 class="modal__title">${genreData.title}</h2>
                        <h3 class="modal__h3">Artistes //</h3>
                        <ul class="modal__list">
                            ${genreData.artists.map(artist => `
                            <li class="modal__artist">
                                <a target="_blank" class="button button--modale" href="${artist.link}")>${artist.name}</a>
                            </li>
                            `).join('')}
                        </ul>
                        <p class="modal__p modal__p--big">${genreData.firstp}</p>
                        ${genreData.pp.map(paragraph => `<p class="modal__p">${paragraph}</p>`).join('')}
                        `
                }
            }
        })

        close.addEventListener('click', () => {
            modal.classList.remove('modal--visible')
            header.classList.add('hide')
            controls.lock()
            togglePressE = false
            isLocked = false
        })

        // Field Height
        function getTerrainHeight(x, z) {
            if (!terrainMesh) {
                return 0
            }

            const raycaster = new THREE.Raycaster()
            const downVector = new THREE.Vector3(0, -1, 0) 
            const startPosition = new THREE.Vector3(x, 100, z) 
            raycaster.set(startPosition, downVector)
            const intersects = raycaster.intersectObject(terrainMesh)

            if (intersects.length > 0) {
                return intersects[0].point.y 
            }

            return 0 
        }


        /**
         * Renderer
         */
        const renderer = new THREE.WebGLRenderer({
            canvas: canvasScene
        })
        renderer.setSize(sizes.width, sizes.height)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


        /**
         * Helper function to find the closest point on the spline
         */
        function getClosestPointOnSpline(position, curve, numPoints = 100) {
            const points = curve.getPoints(numPoints)
            let closestPoint = points[0]
            let minDistance = position.distanceTo(closestPoint)

            points.forEach(point => {
                const distance = position.distanceTo(point)
                if (distance < minDistance) {
                    minDistance = distance
                    closestPoint = point
                }
            })

            return closestPoint
        }

        /**
         * Animate
         */

        const clock = new THREE.Clock()
        const tick = () => {
            const delta = clock.getDelta()

            // Controls
            if (controls.isLocked) {
                frontVector.set(0, 0, 0)
                sideVector.set(0, 0, 0)

                camera.getWorldDirection(frontVector)
                frontVector.y = 0
                frontVector.normalize()

                sideVector.crossVectors(frontVector, new THREE.Vector3(0, 1, 0)).normalize()

                direction.set(0, 0, 0)
                if (moveForward) direction.add(frontVector)
                if (moveBackward) direction.sub(frontVector)
                if (moveLeft) direction.sub(sideVector)
                if (moveRight) direction.add(sideVector)

                direction.normalize()
                velocity.copy(direction).multiplyScalar(moveSpeed * delta)
                controls.getObject().position.add(velocity)

                // Spline
                const closestPoint = getClosestPointOnSpline(camera.position, pathCurve)
                const distanceToSpline = camera.position.distanceTo(closestPoint)
                if (distanceToSpline > 0.3) {
                    const directionToSpline = closestPoint.clone().sub(camera.position).normalize()
                    camera.position.add(directionToSpline.multiplyScalar(distanceToSpline - 0.3))
                }

                // Head bobbing (simule la marche)
                if (moveForward || moveBackward || moveLeft || moveRight) {
                    bobbingTime += delta
                } else {
                    bobbingTime = 0
                }
            }

            // Terrain height
            const terrainHeight = getTerrainHeight(camera.position.x, camera.position.z)

            // Application du head bobbing
            const bobbingOffset = (moveForward || moveBackward || moveLeft || moveRight)
                ? Math.sin(bobbingTime * bobbingSpeed) * bobbingAmplitude
                : 0

            camera.position.y = terrainHeight + 0.05 + bobbingOffset

            // Music
            checkProximity()
            updateAmbianceVolume()

            // 'E'
            if(togglePressE === true) {
                modalInfo.classList.remove('nearSphere--visible')
            }

            // Sphere animation
            spheresExt.forEach((sphereExt) => {
                sphereExt.rotation.y += 0.01
                sphereExt.rotation.x += 0.008
            })
            spheresInt.forEach((sphereInt) => {
                sphereInt.rotation.y -= 0.01
                sphereInt.rotation.x -= 0.008
            })

            // Text rotation
            sphereGroups.forEach(({ textMesh }) => {
                textMesh.rotation.y += 0.04
            })

            // Light Camera
            whiteLight.position.copy(camera.position)

            if (shouldRender) {
            renderer.render(scene, camera)
            }
            window.requestAnimationFrame(tick)
        }
        tick()



        /////////// BACKGROUND EFFECT ///////////
        /**
         * Base
         */
        // Scene
        const sceneBackground = new THREE.Scene()

        // Camera
        const cameraBackground = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 100)
        cameraBackground.position.z = 1


        /**
         * Renderer
         */
        const renderer2 = new THREE.WebGLRenderer({
            canvas: canvasBackground
        })
        renderer2.setSize(window.innerWidth, window.innerHeight)
        renderer2.setPixelRatio(Math.min(window.devicePixelRatio, 2))


        /**
         * Texture
         */
        const loaderBackground = new THREE.TextureLoader(loadingManager)
        const textureBackground = loaderBackground.load('img/home.webp', () => {
            textureBackground.minFilter = THREE.LinearFilter
            textureBackground.magFilter = THREE.LinearFilter
            textureBackground.anisotropy = renderer2.capabilities.getMaxAnisotropy()
            renderer2.render(sceneBackground, cameraBackground)
        })


        /**
         * Uniforms
         */
        const uniforms = {
            uTexture: { value: textureBackground },
            uMouse: { value: new THREE.Vector2(-10, -10) },
            uTime: { value: 0 },
        }


        /**
         * Shaders
         */
        const materialBackground = new THREE.ShaderMaterial({
            uniforms,
            vertexShader: `
                varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                precision mediump float;
                uniform sampler2D uTexture;
                uniform vec2 uMouse;
                uniform float uTime;
                varying vec2 vUv;

                void main() {
                    vec2 mouse = uMouse;

                    // Distance entre chaque fragment et la souris
                    float dist = distance(vUv, mouse);

                    // Déformation plus douce et équilibrée
                    float strength = 0.15 / (dist + 0.15);

                    // Direction de la distorsion
                    vec2 direction = normalize(vUv - mouse);

                    // Application de la déformation
                    vec2 distortedUv = vUv + direction * strength * 0.015;

                    // Échantillonnage de la texture
                    vec4 color = texture2D(uTexture, distortedUv);

                    gl_FragColor = color;
                }
            `,
        })


        /**
         * Geometry
         */
        function getPlaneDimensions() {
            const aspect = window.innerWidth / window.innerHeight
            const height = 2 * Math.tan((cameraBackground.fov * Math.PI) / 360) * cameraBackground.position.z
            const width = height * aspect
            return { width, height }
        }

        const { width, height } = getPlaneDimensions()
        const planeBackground = new THREE.PlaneGeometry(width, height)
        const meshBackground = new THREE.Mesh(planeBackground, materialBackground)
        sceneBackground.add(meshBackground)


        /**
         * Mouse interaction
         */
        window.addEventListener('mousemove', (event) => {
            uniforms.uMouse.value.x = event.clientX / window.innerWidth
            uniforms.uMouse.value.y = 1.0 - event.clientY / window.innerHeight
        })


        /**
         * Resize 
         */
        window.addEventListener('resize', () => {
            const width = window.innerWidth
            const height = window.innerHeight

            // Camera
            cameraBackground.aspect = width / height
            cameraBackground.updateProjectionMatrix()

            // Renderer
            renderer2.setSize(width, height)
            renderer2.setPixelRatio(Math.min(window.devicePixelRatio, 2))

            // Plane size
            const newHeight = 2 * Math.tan((cameraBackground.fov * Math.PI) / 360) * cameraBackground.position.z
            const newWidth = newHeight * cameraBackground.aspect

            // Geometry
            meshBackground.geometry.dispose()
            meshBackground.geometry = new THREE.PlaneGeometry(newWidth, newHeight)
        })


        /**
         * Animation
         */
        function animate(time) {
            uniforms.uTime.value = time * 0.001
            renderer2.render(sceneBackground, cameraBackground)
            requestAnimationFrame(animate)
        }
        animate()
    }

} else {
     /**
     * Sizes
     */
    const sizes = {
        width: window.innerWidth,
        height: window.innerHeight
    }
    document.documentElement.style.setProperty('--screen-width', sizes.width + 'px')
    document.documentElement.style.setProperty('--screen-height', sizes.height + 'px')

    window.addEventListener('resize', () => {
        sizes.width = window.innerWidth
        sizes.height = window.innerHeight

        camera.aspect = sizes.width / sizes.height
        camera.updateProjectionMatrix()

        renderer.setSize(sizes.width, sizes.height)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

        document.documentElement.style.setProperty('--screen-width', sizes.width + 'px')
        document.documentElement.style.setProperty('--screen-height', sizes.height + 'px')
    })
}